import styled from 'styled-components'
import { t } from 'ttag'
import { useQuery } from 'react-query'

import { PlanIcon } from '@h2/components/icons/plan'
import { Link } from '@h2/common/components/link'
import { api } from '@h2/api'
import { Skeleton } from '@h2/components/loading/skeleton'

import { PlanName } from './planName'
import { PlanProgress } from './planProgress'

import { fetchingStyles } from '../fetchingStyles'

const Wrap = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 10px;
  border-radius: 5px;
  grid-area: pln;
  ${fetchingStyles}

  a {
    padding: 10px 20px;
    width: 140px;
    margin-left: auto;
  }
`
const Plan = () => {
  const { data: progress, isFetching } = useQuery(['goals/progress'], () => {
    return api.fetch(`/goals/progress`, { method: 'GET' })
  })
  const activePlan = progress?.activeSequence

  if (isFetching) {
    return (
      <Wrap isFetching={isFetching}>
        <Skeleton height="58px" />
      </Wrap>
    )
  }

  return (
    <Wrap>
      <PlanIcon size="medium" />
      <PlanName name={activePlan?.name} />
      {activePlan && <PlanProgress progress={progress} />}
      {!activePlan && (
        <Link href="/planning/goal" variant="button" weight="bold">
          {t`Create plan`}
        </Link>
      )}
    </Wrap>
  )
}

export { Plan }
